import GARepository from './GARepository';
import { InteractionInputEvent } from './GaTracking';

export default class {
  private gaRepository: GARepository;

  constructor(gaRepository: GARepository) {
    this.gaRepository = gaRepository;
  }

  // TODO could be useful to build "page" and "user" nodes with all their sub-nodes?
  /**
   * Return example:
   *  event: "visit",
   *  page: {},
   *  user: {},
   *  transactionAffiliation: "VOLAGRATIS",
   *  search: {} // additional node
   */
  // eslint-disable-next-line class-methods-use-this
  toFunnelEvent({
    businessProfile,
    page,
    user,
    additionalNodes,
  }: {
    businessProfile: string;
    page: any;
    user: any;
    additionalNodes: any;
  }) {
    const event = {
      event: 'visit',
      page,
      user,
      ...(businessProfile && { transactionAffiliation: businessProfile }),
    };

    return { ...event, ...additionalNodes };
  }

  /**
   * @return example:
   * {
   *  event: "userInteraction",
   *  user: {
   *    interaction: {
   *      action: "pageSectionName"
   *      category: "pageBox"
   *      label: "show-details"
   *    }
   * }
   */
  // eslint-disable-next-line class-methods-use-this
  toInteraction({ pageElementName, pageSectionName, label, interactive, additionalNodes }: InteractionInputEvent) {
    const event = {
      event: 'userInteraction',
      user: {
        interaction: {
          category: pageElementName && pageElementName.toLowerCase(),
          action: pageSectionName && pageSectionName.toLowerCase(),
          label,
        },
      },
    };

    if (interactive === false || interactive === true) {
      // @ts-ignore
      event.user.interaction.n = convertInteractiveHit(interactive);
    }

    return { ...event, ...additionalNodes };
  }

  /**
   * @deprecated
   * @return example:
   * {
   *  event: "userInteraction",
   *  user: {
   *    interaction: {
   *      action: "volagratis_it"
   *      category: "concorde_bkFlow-flight"
   *      label: "show-details"
   *    }
   * }
   */
  toUserInteraction({ name, optionalString, subject, additionalNodes }) {
    const formattedOptionalString = optionalString ? `_${optionalString}` : '';

    // this is an exceptional case that uses locale and brand from platformData
    let brand = this.gaRepository.getBrand();
    let platformName = this.gaRepository.getPlatformName();
    const country = getCountryFrom(this.gaRepository.getLocale());
    const category = this.gaRepository.getCategory();
    const pageType = this.gaRepository.getPageType();

    brand = brand && brand.toLowerCase();
    platformName = platformName && platformName.toLowerCase();

    const event = {
      event: 'userInteraction',
      user: {
        interaction: {
          category: `${platformName}_${pageType}-${category}`,
          action: `${brand}_${country}`,
          label: `${name}${formattedOptionalString}`,
        },
      },
    };

    if (subject) {
      // @ts-ignore
      event.user.interaction.subject = subject;
    }

    return { ...event, ...additionalNodes };
  }

  // eslint-disable-next-line class-methods-use-this
  toCustomEvent({ name }) {
    return {
      event: name,
    };
  }
}

function getCountryFrom(locale) {
  try {
    return locale.split('_')[1] || locale; // fallback in case of locale without country
  } catch (e) {
    return locale;
  }
}

function convertInteractiveHit(interactive: boolean) {
  const interactiveMap = {
    true: 0,
    false: 1,
  };

  return interactiveMap[interactive.toString()];
}
